module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"sectionFilter":"Buscar","create":"Crear risk policy","policyFilter":"Filtrar por etiquetas"},"pe":{"sectionFilter":"Buscar","create":"Crear risk policy","policyFilter":"Filtrar por etiquetas"},"br":{"sectionFilter":"Buscar","create":"Criar risk policy","policyFilter":"Filtrar por etiquetas"}}')
  delete Component.options._Ctor
}
